import React from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { osVersion, osName } from 'react-device-detect';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    textcustomertitle: {
        [theme.breakpoints.up('xs')]: {
            color : '#009aa8',
            fontSize: '130%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('sm')]: {
            color : '#009aa8',
            fontSize: '130%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('md')]: {
            color : '#009aa8',
            fontSize: '130%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('lg')]: {
            color : '#009aa8',
            fontSize: '130%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('xl')]: {
            color : '#009aa8',
            fontSize: '130%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        }
    },
    textcustomerheader: {
        [theme.breakpoints.up('xs')]: {
            color : '#009aa8',
            fontSize: '100%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('sm')]: {
            color : '#009aa8',
            fontSize: '100%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('md')]: {
            color : '#009aa8',
            fontSize: '100%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('lg')]: {
            color : '#009aa8',
            fontSize: '100%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        },
        [theme.breakpoints.up('xl')]: {
            color : '#009aa8',
            fontSize: '100%',
            fontWeight: 'bold',
            fontFamily: 'Ubuntu',
        }
    },
    textlastaccessheader: {
        [theme.breakpoints.up('xs')]: {
            color : '#1a1919',
            fontSize: '80%',
            fontFamily: 'Ubuntu',

        },
        [theme.breakpoints.up('sm')]: {
            color : '#1a1919',
            fontSize: '100%',
            fontFamily: 'Ubuntu',

        },
        [theme.breakpoints.up('md')]: {
            color : '#1a1919',
            fontSize: '100%',
            fontFamily: 'Ubuntu',

        },
        [theme.breakpoints.up('lg')]: {
            color : '#1a1919',
            fontSize: '100%',
            fontFamily: 'Ubuntu',

        },
        [theme.breakpoints.up('xl')]: {
            color : '#1a1919',
            fontSize: '100%',
            fontFamily: 'Ubuntu',

        }

    }
}));


const InfoDeviceUser = props => {

    const { customer, verificates } = props;

    const classes2 = useStyles()

    return (
        <div>
            <Typography className = {classes2.textcustomertitle} align = "left">

                {
                    "Bienvenido "//+user.customer.first_name + " " + user.customer.surname
                }

            </Typography>
            <Typography className = {classes2.textcustomerheader} align = "left">

                {
                    (customer.EsPersonaNatural === true) ?
                        customer.Nombres + " " + customer.Apellidos + " - " + customer.Identificacion
                    :
                        customer.RazonSocial + " - " + customer.Identificacion
                }

            </Typography>

            <br />
            <Typography className = {classes2.textlastaccessheader} align = "left">
                    <strong>{"Ultimo acceso"}</strong>
                    <br/>
                    {moment(verificates.updatedAt).format('DD/MM/YYYY')}
                    <br/>
                    {moment(verificates.updatedAt).format('HH:mm:ss')}
                    <br/>
                    {osName} {osVersion}
            </Typography>
        </div>
    )
}

export default InfoDeviceUser
